module.exports = __webpack_public_path__ + "./docs/img/icon-twitter.5e5502337f1ba688e7469da70591b9a3.svg";